import React from "react"

import PopoverMenuItem from "../../popover-menu/popover-menu/menu-item"

type Props = {
    menuParams? : any,

    hidePopover : {():void}
}

export default class PopoverMenuAddAttachment extends React.Component<Props> {

    onFromComputer      = () => {
        this.props.menuParams.onFromComputer()
        this.props.hidePopover()
    }

    onFromGoogleDrive   = () => {
        this.props.menuParams.onFromGoogleDrive()
        this.props.hidePopover()
    }

    render() {
        const {} = this.props.menuParams

        const showGoogleDrive = !!gd.session.modules.get(gd.companyId)?.gDrive

        return (
            <div className="ui5-popover-menu with-help min-w-150">
                <PopoverMenuItem icon       = "i5-attachment"
                                 label      = "From Computer"
                                 onClick    = {this.onFromComputer}/>
                {showGoogleDrive &&
                    <PopoverMenuItem icon       = "i5-gdrive"
                                     label      = "Google Drive"
                                     onClick    = {this.onFromGoogleDrive}/>}

                <div className="help max-w-200-no-truncate">
                    Drag'n'drop files into application area
                </div>
            </div>
        )
    }
}